import React from "react";
import "./feature.css";

const Feature = (props) => {
  return (
    <>
      <div className={"gpt3__feature " + props.type}>
        <h4 className="gpt3__feature-row_title">{props.title}</h4>
        <p className="gpt3__feature-row_p">{props.text}</p>
      </div>
    </>
  );
};

export default Feature;
